import { PlusCircleOutlined } from "@ant-design/icons";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, Input, Form, Row, Col, message, Switch } from "antd";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import GoBackButton from "../../../components/common/buttons/GoBackButton";
import { useNavigate } from "react-router-dom";
import { mutationOnErrorHandler } from "../../../utils/mutationUtils";
import WelcomeTopbar from "../../../components/common/header/WelcomeTopbar";
import { createTagRequest } from "../../../api/requests/tag";

const createTagSchemaResolver = yupResolver(
  yup.object().shape({
    name: yup.string().required("Name is required"),
    description: yup.string(),
    customAttributes: yup.object().shape({
      type: yup.string(),
      size: yup
        .number()
        .positive("Size must be positive")
        .integer("Size must be an integer"),
      color: yup.string(),
    }),
    active: yup.boolean(),
  }),
);

function AddTagPage() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { mutateAsync: createTag } = useMutation({
    mutationFn: async (data) => {
      const res = await createTagRequest(data);
      return res.data;
    },
    mutationKey: ["tag/create"],
    onSuccess: (res) => {
      queryClient.invalidateQueries(["tag"]);
      const successMessage = res?.message;
      if (successMessage) {
        message.success(successMessage);
      }
      navigate(-1);
    },
    onError: (error) => {
      mutationOnErrorHandler({ error, message });
    },
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: createTagSchemaResolver,
    defaultValues: {
      active: true,
    },
  });

  async function onSubmit(data) {
    console.log(data);
    const res = await createTag(data);
    console.log("res----->", res);
  }

  return (
    <div className="flex flex-col gap-6">
      <WelcomeTopbar />
      <div className="flex flex-col gap-5 px-6 pb-6">
        <div className="flex items-center gap-5">
          <GoBackButton />
        </div>
        <div className="flex flex-col gap-6 rounded-xl border-2">
          <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
            <div className="flex items-center justify-between rounded-t-xl bg-[#D1DFFF] px-6 py-3">
              <div className="flex items-center gap-2 text-2xl">
                <PlusCircleOutlined />
                <div>Tag Details</div>
              </div>
              <Button
                type="primary"
                htmlType="submit"
                className="flex items-center justify-center"
              >
                Save
              </Button>
            </div>
            <div className="px-6 py-6">
              <Row gutter={18}>
                <Col span={12}>
                  <Form.Item
                    label="Name"
                    name="name"
                    validateStatus={errors.name ? "error" : ""}
                    help={errors.name && errors.name.message}
                  >
                    <Controller
                      control={control}
                      name="name"
                      render={({ field }) => (
                        <Input {...field} placeholder="Name" />
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Description"
                    name="description"
                    validateStatus={errors.description ? "error" : ""}
                    help={errors.description && errors.description.message}
                  >
                    <Controller
                      control={control}
                      name="description"
                      render={({ field }) => (
                        <Input {...field} placeholder="Description" />
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Type"
                    name="customAttributes.type"
                    validateStatus={
                      errors.customAttributes?.type ? "error" : ""
                    }
                    help={errors.customAttributes?.type?.message}
                  >
                    <Controller
                      control={control}
                      name="customAttributes.type"
                      render={({ field }) => (
                        <Input {...field} placeholder="Type" />
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Size"
                    name="customAttributes.size"
                    validateStatus={
                      errors.customAttributes?.size ? "error" : ""
                    }
                    help={errors.customAttributes?.size?.message}
                  >
                    <Controller
                      control={control}
                      name="customAttributes.size"
                      render={({ field }) => (
                        <Input {...field} placeholder="Size" />
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Color"
                    name="customAttributes.color"
                    validateStatus={
                      errors.customAttributes?.color ? "error" : ""
                    }
                    help={errors.customAttributes?.color?.message}
                  >
                    <Controller
                      control={control}
                      name="customAttributes.color"
                      render={({ field }) => (
                        <Input {...field} placeholder="Color" />
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Active"
                    name="active"
                    validateStatus={errors.active ? "error" : ""}
                    help={errors.active?.message}
                  >
                    <Controller
                      control={control}
                      name="active"
                      render={({ field }) => <Switch {...field} />}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default AddTagPage;
